import { NavBar } from "../Components/NavBar"
import "../CSSFiles/CustomerSignUp.css"
import { useState, useRef, useEffect } from "react"

export const CustomerSignUp = () => {


    const [phone_number, set_phone_number] = useState("")
    const [error_message, set_error_message] = useState("")

    const name_ref = useRef(null);
    const email_ref = useRef(null);
    const make_ref = useRef(null);
    const model_ref = useRef(null);
    const year_ref = useRef(null);

    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];

    const submitHandler = (e) => {
      e.preventDefault();

        console.log(name_ref.current.value);
        console.log(email_ref.current.value);
        console.log(make_ref.current.value);
        console.log(model_ref.current.value);
        console.log(year_ref.current.value);


    };

    const HandlePhoneNumberChange = (e) => {

    const current_value = phone_number.replace(/\D/g, '')
    const current_value_length = current_value.length

    const value = e.target.value.replace(/\D/g, '');
    const value_length = value.length;

    if (value.length > 10)
      return;

    let new_val = null;

    if (e.target.value.length < phone_number.length) {
      new_val = value
      set_phone_number(new_val)
    }
    else if (value_length > current_value_length && (value[value_length - 1] >= 0 && value[value_length - 1] <= 9)) {
      new_val = value
    }
    
    if (!new_val)
      return;


    set_phone_number(FormatNumber(new_val))

    }

    function FormatNumber(input) {
    let returned_string = "("
    for (let i = 0; i < input.length; i++) {
      switch(i) {
        case 3:
          returned_string += (")" + "-"  + input[i])
          break
        case 6:
          returned_string += ("-" + input[i])
          break;
        default:
          returned_string += input[i]
      }
    }


    return returned_string
    }


    return <div className="customer_sign_up"> 
        <NavBar />
        <div className="title_section">
            <h1> Please Enter your Information</h1>
        </div>

         <form onSubmit={submitHandler} className="form_appointment">
        <div className="customer_inputs_section">
           <div className="info_part" style={{ justifyContent: "center" }}>
  <div className="input_component">
    <label htmlFor="input_name_x">Name:</label>
    <input
      autoComplete="off"
      required
      type="text"
      ref={name_ref}
      id="input_name_x"
      name="no_autofill_name"
      placeholder="John Doe"
    />
  </div>
</div>

<div className="info_part">
  <div className="input_component">
    <label htmlFor="input_phone_x">Phone Number:</label>
    <input
      autoComplete="off"
      required
      type="text"
      value={phone_number}
      id="input_phone_x"
      name="no_autofill_phone"
      placeholder="(571)-598-4191"
      pattern="\([0-9]{3}\)-[0-9]{3}-[0-9]{4}"
      onChange={HandlePhoneNumberChange}
    />
  </div>
</div>

<div className="info_part">
  <div className="input_component">
    <label htmlFor="input_email_x">Email:</label>
    <input
      autoComplete="off"
      required
      type="email"
      ref={email_ref}
      id="input_email_x"
      name="no_autofill_email"
      placeholder="novaautor@gmail.com"
    />
  </div>
</div>

          <div className="info_part">
            <div className="input_component">
              <label htmlFor='make'>Vehicle Make: </label>
              <input autoComplete="off"required type="text" id="make" placeholder='Toyota' ref={make_ref} />
            </div >
          </div>
           <div className="info_part">
            <div className="input_component">
              <label htmlFor='model'>Vehicle Model: </label>
              <input autoComplete="off"required type="text" id="model" placeholder='Camry' ref={model_ref} />
            </div >
          </div>
          <div className="info_part">
            <div className="input_component">
              <label htmlFor='vehicle_year'>Vehicle Year: </label>
              <input autoComplete="off"required type="number" id="vehicle_year" placeholder='2020' ref={year_ref} />
            </div >
          </div>
          
          {/* <div className="info_part">
            <div className="input_component" style={{width: "100%"}}>
              <label htmlFor='purpose'>Purpose: </label>
              <textarea id="purpose" ref={purpose_ref} placeholder='I would like to get my car’s health checked....'></textarea>
            </div >
      
          </div> */}
        </div>
      
        <p className="submit-error"> {error_message}</p>
        <button type="submit" className="submit-appointment"> Submit </button>
        </form>

    </div>
}